module.exports = __webpack_public_path__ + "assets/img/travel-day6.27645dd6.png";